import React, {ReactNode, RefObject} from 'react'
import {SpApplyDialogTitle, SpApplyDialogTitleFont} from './NatAdminApplicationCommon'
import {RowFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {DialogCloseButton} from '../../../../../components/reservations/components/CommonStyle'
import {Close} from '@mui/icons-material'
import { Box, DialogContent, Paper, Button } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import ReactToPrint from 'react-to-print'
import {Colors} from '../../../../../styledComponents/Constants'
import {faFilePdf} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import styled from 'styled-components'
import {PrintContentArea} from './print/NatAdminApplicatioPrintCommonStyle'
import {AdminDialog} from '../../../../../components/shared/pageBaseComponents/AdminDialog'

interface Props {
    open: boolean
    onCancel: () => void
    firstDocument: ReactNode
    firstDocumentName: string
    firstDocumentPageOrientation?: PageOrientation
    secondDocument: ReactNode
    secondDocumentName: string
    secondDocumentPageOrientation?: PageOrientation
}

type PageOrientation = 'portrait' | 'landscape'

export const NatAdminSpApplicationPrintSelectDialog: React.FC<Props> = props => {
    const applicationRef: RefObject<HTMLDivElement> = React.createRef()
    const contractRef: RefObject<HTMLDivElement> = React.createRef()

    const handleClickCloseButton = () => {
        props.onCancel()
    }

    return (
        <AdminDialog
            open={props.open}
        >
            <SpApplyDialogTitle>
                <RowFlexContainer>
                    <SpApplyDialogTitleFont>
                        印刷
                    </SpApplyDialogTitleFont>
                    <DialogCloseButton onClick={handleClickCloseButton}>
                        <Close fontSize={'large'}/>
                    </DialogCloseButton>
                </RowFlexContainer>
            </SpApplyDialogTitle>
            <DialogContent>
                <Box pt={'16px'} pb={'8px'}>印刷する書類を選択してください。</Box>
                <ReactToPrint
                    trigger={() => (
                        <PrintButton
                            variant={'outlined'}
                        >
                            <FontAwesomeIcon icon={faFilePdf} color={Colors.AccentDark} size={'lg'}/>
                            <PrintButtonLabel>{props.firstDocumentName}.pdf</PrintButtonLabel>
                        </PrintButton>
                    )}
                    pageStyle={
                        props.firstDocumentPageOrientation === 'landscape'
                            ? '@page { size: landscape; margin: 0;}' : undefined
                    }
                    content={() => applicationRef.current}/>
                <PrintContentArea>
                    <div ref={applicationRef}>
                        {props.firstDocument}
                    </div>
                </PrintContentArea>
                <ReactToPrint
                    trigger={() => (
                        <PrintButton
                            variant={'outlined'}
                        >
                            <FontAwesomeIcon icon={faFilePdf} color={Colors.AccentDark} size={'lg'}/>
                            <PrintButtonLabel>{props.secondDocumentName}.pdf</PrintButtonLabel>
                        </PrintButton>
                    )}
                    pageStyle={
                        props.secondDocumentPageOrientation === 'landscape'
                            ? '@page { size: landscape; margin: 0;}' : undefined
                    }
                    content={() => contractRef.current}/>
                <PrintContentArea>
                    <div ref={contractRef}>
                        {props.secondDocument}
                    </div>
                </PrintContentArea>
            </DialogContent>
        </AdminDialog>
    )
}

const PrintButton = withStyles({
    root: {
        outlineColor: Colors.AccentLight,
        width: '100%',
        height: '55px',
        marginTop: '8px',
        justifyContent: 'flex-start',
        flexDirection: 'row',
    },
})(Button)

const PrintButtonLabel = styled.span`
  padding-left: 8px;
  text-transform: lowercase;
`
